<span contenteditable="false">{{ content?.value }}</span>
